import React, { FC } from 'react';

import { useTags, useTagSchemas } from '@sbu/hooks.tags';

import {
  isSupportedSource,
  useTagOptions,
} from 'shared/components/internal/Tags';

import { defaultSources, Filter, FilterProps } from '../Filter';
import { deserializeQuery, serializeQuery } from './serializer';

interface SearchFilterProps extends FilterProps {
  dslString: string;
  postProcessFilter?: (filter: any) => void;
  preProcessFilter?: (filter: any) => void;
  onQueryStringChange: (query: string) => void;
}

export const SearchFilter: FC<
  React.PropsWithChildren<Partial<SearchFilterProps>>
> = ({
  activeSource,
  dslString = '',
  fields,
  postProcessFilter,
  preProcessFilter,
  sources = defaultSources,
  showSources = false,
  onQueryStringChange = () => undefined,
  ...rest
}) => {
  const filters = deserializeQuery(dslString, postProcessFilter, fields);

  const isTagsFilterSupported =
    !!activeSource && isSupportedSource(activeSource);
  const { tagSchemas } = useTagSchemas(!isTagsFilterSupported);
  const { tagOptions } = useTagOptions(
    isTagsFilterSupported ? activeSource : undefined
  );
  const { deserializeTag } = useTags(tagSchemas);

  return (
    <Filter
      {...rest}
      activeSource={activeSource}
      deserializeKeyValue={deserializeTag}
      fields={fields}
      filters={filters}
      onFilterChange={(changedFilters) =>
        onQueryStringChange(serializeQuery(changedFilters, preProcessFilter))
      }
      showSources={showSources}
      sources={sources}
      tagAutocompleteList={tagOptions}
      tagSchemas={tagSchemas}
    />
  );
};
